import {
  addAddressDetailsAPI,
  addIndexDataAPI,
  addIndexDetailsAPI,
  deleteAddressDetailsAPI,
  getAddressDetailsAPI,
  getIndexListAPI,
  getMyIndexListAPI,
  getSingleAddressDetailsAPI,
  getVesselIndexesAPI,
  updateAddressDetailsAPI,
  updateIndexDetailsAPI,
} from "./api";

export const addAddressDetails = (id, data) => {
  return new Promise((resolve, reject) => {
    addAddressDetailsAPI(id, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateAddressDetails = (data) => {
  return new Promise((resolve, reject) => {
    updateAddressDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getAddressDetails = (data) => {
  return new Promise((resolve, reject) => {
    getAddressDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getSingleAddressDetails = (data) => {
  return new Promise((resolve, reject) => {
    getSingleAddressDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};



export const deleteAddressDetails = (data) => {
  return new Promise((resolve, reject) => {
    deleteAddressDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


export const getVesselIndexes = (data) => {
  return new Promise((resolve, reject) => {
    getVesselIndexesAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addIndexDetails = (data) => {
  return new Promise((resolve, reject) => {
    addIndexDetailsAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getIndexList = (data) => {
  return new Promise((resolve, reject) => {
    getIndexListAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getMyIndexList = (data) => {
  return new Promise((resolve, reject) => {
    getMyIndexListAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateIndexDetails = (params, data) => {
  return new Promise((resolve, reject) => {
    updateIndexDetailsAPI(params, data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addIndexData = (data) => {
  return new Promise((resolve, reject) => {
    addIndexDataAPI(data)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};